/**
 * Opções do filtro "Campanhas WhatsApp": omnichannel (leads.campaign_id)
 * + legado whatsapp_campaigns (leads.whatsapp_campaign_id).
 */

function asChannels(raw) {
  if (Array.isArray(raw)) return raw.map(String);
  return String(raw || "")
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
}

export function isWhatsappBroadcastCampaign(campaign) {
  return asChannels(campaign?.channels).includes("whatsapp");
}

export function mergeWhatsappFilterOptions({ broadcasts = [], legacyWhatsapp = [] } = {}) {
  const omni = (broadcasts || [])
    .filter(
      (c) => c?.filterTarget === "campaign" || isWhatsappBroadcastCampaign(c)
    )
    .map((c) => {
      const id = Number(c?.id);
      return {
        ...c,
        id,
        name: c?.name || c?.nome || `#${id}`,
        filterTarget: "campaign",
        filterKey: `campaign:${id}`,
      };
    })
    .filter((c) => Number.isFinite(c.id) && c.id > 0);

  const legacy = (legacyWhatsapp || [])
    .map((c) => {
      const id = Number(c?.id);
      return {
        ...c,
        id,
        name: c?.name || c?.nome || `#${id}`,
        filterTarget: "whatsapp_campaign",
        filterKey: `whatsapp_campaign:${id}`,
      };
    })
    .filter((c) => Number.isFinite(c.id) && c.id > 0);

  return [...omni, ...legacy];
}

export function splitWhatsappFilterSelection(selectedKeys, options = []) {
  const byKey = new Map((options || []).map((o) => [o.filterKey, o]));
  const ids_campaigns = [];
  const ids_whatsapp_campaigns = [];

  for (const key of selectedKeys || []) {
    const o = byKey.get(key);
    if (o) {
      if (o.filterTarget === "campaign") ids_campaigns.push(Number(o.id));
      else ids_whatsapp_campaigns.push(Number(o.id));
      continue;
    }
    const s = String(key || "");
    if (s.startsWith("campaign:")) {
      const id = Number(s.slice("campaign:".length));
      if (Number.isFinite(id) && id > 0) ids_campaigns.push(id);
    } else if (s.startsWith("whatsapp_campaign:")) {
      const id = Number(s.slice("whatsapp_campaign:".length));
      if (Number.isFinite(id) && id > 0) ids_whatsapp_campaigns.push(id);
    } else {
      // Compat: seleção numérica antiga = legado
      const id = Number(key);
      if (Number.isFinite(id) && id > 0) ids_whatsapp_campaigns.push(id);
    }
  }

  return {
    ids_campaigns: [...new Set(ids_campaigns)],
    ids_whatsapp_campaigns: [...new Set(ids_whatsapp_campaigns)],
  };
}

export function whatsappKeysFromFilterState(
  { ids_campaigns = [], ids_whatsapp_campaigns = [] } = {},
  options = []
) {
  const campSet = new Set((ids_campaigns || []).map(Number));
  const waSet = new Set((ids_whatsapp_campaigns || []).map(Number));
  return (options || [])
    .filter((o) => {
      if (o.filterTarget === "campaign") return campSet.has(Number(o.id));
      return waSet.has(Number(o.id));
    })
    .map((o) => o.filterKey);
}
